import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-tenant-role-wizard',
  imports: [],
  templateUrl: './tenant-role-wizard.component.html',
  styleUrl: './tenant-role-wizard.component.scss'
})
export class TenantRoleWizardComponent {
  @Input() title = '';
  @Input() size: 'sm' | 'md' | 'lg' = 'md';
  @Output() closed = new EventEmitter<void>();

  close(): void {
    this.closed.emit();
  }
}
